import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocalDataSource } from 'ng2-smart-table';
import { CookieService } from 'ngx-cookie-service';
import { PAGE_CODE_MAP, TranslationService } from '../../../tool/language/translation.service';

@Component({
  selector: 'ngx-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
@Injectable({
  providedIn: 'root'
})
export class HomeComponent implements OnInit, OnDestroy {
  private readonly translationPageCodes = PAGE_CODE_MAP.sys;

  dataList = [];
  Source: LocalDataSource;
  translationReady = false;

  ORG_Company_ID: number;
  ORG_Store_ID: number;

  cntractRd = '';
  languageChangeSub: any;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private translationService: TranslationService,
  ) {
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'), 10);
    const cookieSid = this.cookieService.get('ORG_Store_ID');
    this.ORG_Store_ID = (cookieSid && cookieSid !== '') ? parseInt(cookieSid, 10) : null;
  }

  async ngOnInit(): Promise<void> {
    this.translationService.initLanguage();
    this.translationService.setCurrentPageCodes(this.translationPageCodes);
    this.languageChangeSub = this.translationService.languageChanged$.subscribe(() => {
      this.GetContractRd();
      this.translationReady = true;
    });

    await this.translationService.loadTranslations(this.translationPageCodes);
    this.GetContractRd();
    this.translationReady = true;

    const perPage = 10;
    this.Source = new LocalDataSource();
    this.Source.setPaging(1, perPage, false);
    this.GetMainList();
  }

  ngOnDestroy(): void {
    if (this.languageChangeSub) {
      this.languageChangeSub.unsubscribe();
    }
  }

  onPage(v): void {
    console.log('page', v);
    this.GetMainList();
  }

  GetMainList(): void {
    let perPage = 10;
    let page = 1;

    if (this.Source && this.Source.getPaging()) {
      const pagingConf = this.Source.getPaging();
      page = pagingConf.page;
      perPage = pagingConf.perPage;
    }

    this.http.get<any>(
      'api/News/GetNews?' +
      'Page=' + page +
      '&PerPage=' + perPage +
      '&IsDelete=true'
    ).subscribe({
      next: (data) => {
        if (data.RESULT != null && data.RESULT !== '') {
          alert(data.RESULT);
          return;
        }

        this.dataList = data.LIST || [];

        this.dataList.forEach((x: any) => {
          if (x.StoreList) {
            x.StoreShow = x.StoreList.map((store: any) => store.StoreName).join('、');
          }
        });

        this.Source.load(new Array(data.Total));
      },
      error: () => {},
    });
  }

  GetContractRd(): void {
    const cookieSid = this.cookieService.get('ORG_Store_ID');
    const sid = (cookieSid && cookieSid !== '') ? parseInt(cookieSid, 10) : null;

    this.http.post<any>('api/Contract/ContractRemind', {
      ORG_Company_ID: this.ORG_Company_ID,
      ORG_Store_ID: sid === 0 ? null : sid,
    }).subscribe({
      next: (data) => {
        this.cntractRd = data?.TipContant || '';
      },
      error: (error) => {
        console.error('There was an error!', error);
      }
    });
  }
}
